import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetRelationsDocument,
  type GetRelationsQuery,
  type GetRelationsQueryVariables,
} from "~/features/relations/gqls";
import type { RelationListFilters, RelationSortOrder, SortDirection } from "~/features/relations/types";
import { buildRelationsVariables } from "~/features/relations/utils/transformers";
import { useTenant } from "~/features/tenant/context";

interface UseRelationListArgs {
  filters: RelationListFilters;
  sortOrder: RelationSortOrder;
  direction: SortDirection;
  pageIndex: number;
  pageSize: number;
}

/**
 * Server-paginated list of relation records for the current tenant. Variables
 * (where / orderBy / limit / offset) are built from the URL-derived filters.
 * Keeps the V1 `tenantId` variable (see plan — explicit decision).
 */
export function useRelationList({ filters, sortOrder, direction, pageIndex, pageSize }: UseRelationListArgs) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetRelationsQuery, GetRelationsQueryVariables>(GetRelationsDocument, {
    variables: buildRelationsVariables({ tenantId, filters, sortOrder, direction, pageIndex, pageSize }),
  });
}
